module.exports = __webpack_public_path__ + "img/uganda.3805be1a.svg";